import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const BookedIcon = React.memo(
  ({ fill = variables['colors-mc-primary'], width = 146.11, viewBox = '0 0 146.11 146.11' }) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      width={remCss(width)}
      height={remCss(width)}
      viewBox={viewBox}
    >
      <defs>
        <radialGradient
          id='radial-gradient'
          cx='0.5'
          cy='0.5'
          r='0.5'
          gradientUnits='objectBoundingBox'
        >
          <stop offset='0' stopColor={fill} />
          <stop offset='1' stopColor='#fff' />
        </radialGradient>
        <linearGradient
          id='linear-gradient'
          x1='-0.135'
          y1='1.384'
          x2='-0.134'
          y2='1.382'
          gradientUnits='objectBoundingBox'
        >
          <stop offset='0' stopColor='#d4e1f4' />
          <stop offset='0.172' stopColor='#e5e8fe' />
          <stop offset='0.2' stopColor='#d4e1f4' />
          <stop offset='0.2' stopColor='#dae4f4' />
          <stop offset='0.201' stopColor='#ebebf4' />
          <stop offset='0.201' stopColor='#f6f1f4' />
          <stop offset='0.202' stopColor='#fdf4f4' />
          <stop offset='0.205' stopColor='#fff5f4' />
          <stop offset='0.252' stopColor='#e5e8fe' />
          <stop offset='0.26' stopColor='#fff5f4' />
          <stop offset='0.26' stopColor='#d4e1f4' />
          <stop offset='0.397' stopColor='#d4e1f4' />
          <stop offset='0.42' stopColor='#d4e1f4' />
          <stop offset='0.42' stopColor='#dae4f4' />
          <stop offset='0.421' stopColor='#ebebf4' />
          <stop offset='0.421' stopColor='#f6f1f4' />
          <stop offset='0.422' stopColor='#fdf4f4' />
          <stop offset='0.425' stopColor='#fff5f4' />
          <stop offset='0.489' stopColor='#fff5f4' />
          <stop offset='0.5' stopColor='#fff5f4' />
          <stop offset='0.5' stopColor='#f9f2f4' />
          <stop offset='0.5' stopColor='#e8ebf4' />
          <stop offset='0.5' stopColor='#dde5f4' />
          <stop offset='0.501' stopColor='#d6e2f4' />
          <stop offset='0.501' stopColor='#d4e1f4' />
          <stop offset='0.706' stopColor='#d4e1f4' />
          <stop offset='0.74' stopColor='#d4e1f4' />
          <stop offset='0.741' stopColor='#fff5f4' />
          <stop offset='0.835' stopColor='#fff5f4' />
          <stop offset='0.85' stopColor='#fff5f4' />
          <stop offset='0.851' stopColor='#d4e1f4' />
          <stop offset='1' stopColor='#d4e1f4' />
        </linearGradient>
        <linearGradient
          id='linear-gradient-2'
          x1='0.5'
          x2='0.5'
          y2='1'
          gradientUnits='objectBoundingBox'
        >
          <stop offset='0' stopColor={fill} />
          <stop offset='1' stopColor='#3fe4d6' />
        </linearGradient>
        <linearGradient
          id='linear-gradient-23'
          x1='0.5'
          x2='0.5'
          y2='1'
          gradientUnits='objectBoundingBox'
        >
          <stop offset='0' stopColor={fill} />
          <stop offset='1' stopColor='#4df895' />
        </linearGradient>
      </defs>
      <g id='Group_2462' data-name='Group 2462' transform='translate(-119.445 -129.945)'>
        <g id='Group_2444' data-name='Group 2444' transform='translate(5 -100)'>
          <path
            id='Path_2089'
            data-name='Path 2089'
            d='M73.055,0c14.8,0,73.055,58.248,73.055,73.055S87.038,146.11,73.055,146.11,0,88.973,0,73.055,58.26,0,73.055,0Z'
            transform='translate(114.445 229.945)'
            opacity='0.152'
            fill='url(#radial-gradient)'
          />
          <g id='star-3' transform='translate(180.938 332.394)' opacity='0.489'>
            <path
              id='Path_2085'
              data-name='Path 2085'
              d='M15.791,20.992l2.055,4.165,4.6.668-3.326,3.242.785,4.578-4.111-2.161-4.111,2.161.785-4.578L9.14,25.824l4.6-.668Z'
              transform='translate(-8.893 -8.497)'
              fill='#a4c2f7'
            />
            <path
              id='Path_2086'
              data-name='Path 2086'
              d='M24.347,61.408l-4.6-.668-1.578-3.177L16.692,60.74l-4.6.668,3.326,3.242-.785,4.577,3.29-2.033.442.166s0-.007,0-.01a.274.274,0,0,1,.329-.187,2.147,2.147,0,0,1,.866.356.326.326,0,0,1,.091.108.227.227,0,0,1,.1.083.269.269,0,0,1,.106-.022.238.238,0,0,1,.241.179.257.257,0,0,1,.379.284l1.4.524-.856-4.026Z'
              transform='translate(-11.77 -44.08)'
              fill='url(#linear-gradient)'
            />
            <path
              id='Path_2087'
              data-name='Path 2087'
              d='M13.859,175.177l-4.6.668,3.326,3.242-.785,4.577,1.181-.621a.272.272,0,0,1-.016-.029l-.264.1.856-4.026-3.326-3.242,3.454-.634Z'
              transform='translate(-9.013 -158.518)'
              fill='#fff'
            />
            <path
              id='Path_2088'
              data-name='Path 2088'
              d='M11.728,26.252a.263.263,0,0,1-.123-.03L7.349,23.984,3.092,26.222a.263.263,0,0,1-.382-.277l.813-4.74L.079,17.847A.263.263,0,0,1,.225,17.4l4.759-.692,2.129-4.313a.274.274,0,0,1,.472,0l2.129,4.313,4.759.692a.263.263,0,0,1,.146.449L11.175,21.2l.813,4.74a.263.263,0,0,1-.259.308ZM7.349,23.424a.262.262,0,0,1,.123.03l3.907,2.054-.746-4.351a.263.263,0,0,1,.076-.233l3.161-3.082L9.5,17.208a.263.263,0,0,1-.2-.144L7.349,13.1,5.4,17.064a.263.263,0,0,1-.2.144l-4.369.635L3.99,20.924a.263.263,0,0,1,.076.233l-.746,4.351,3.907-2.054A.262.262,0,0,1,7.349,23.424Z'
              transform='translate(-0.902)'
              stroke={fill}
              strokeWidth='0.5'
              fill='url(#linear-gradient-2)'
            />
          </g>
          <g id='star-3-2' data-name='star-3' transform='translate(163.673 323.95)' opacity='0.524'>
            <path
              id='Path_2085-2'
              data-name='Path 2085'
              d='M12.411,20.992l1.011,2.048,2.26.328-1.636,1.594.386,2.251-2.022-1.063L10.39,27.214l.386-2.251L9.14,23.369l2.26-.328Z'
              transform='translate(-9.477 -8.617)'
              fill='#a4c2f7'
            />
            <path
              id='Path_2086-2'
              data-name='Path 2086'
              d='M18.121,59.454l-2.26-.328-.776-1.562-.729,1.562-2.26.328,1.636,1.594L13.345,63.3l1.618-1,.217.081s0,0,0-.005a.135.135,0,0,1,.162-.092,1.056,1.056,0,0,1,.426.175.16.16,0,0,1,.045.053.112.112,0,0,1,.049.041.132.132,0,0,1,.052-.011.117.117,0,0,1,.119.088.126.126,0,0,1,.186.14l.687.258-.421-1.98Z'
              transform='translate(-12.394 -44.702)'
              fill='url(#linear-gradient)'
            />
            <path
              id='Path_2087-2'
              data-name='Path 2087'
              d='M11.523,175.177l-2.26.328L10.9,177.1l-.386,2.251.581-.305-.008-.014-.13.049.421-1.98-1.636-1.594,1.7-.312Z'
              transform='translate(-9.599 -160.754)'
              fill='#fff'
            />
            <path
              id='Path_2088-2'
              data-name='Path 2088'
              d='M5.768,19.141a.129.129,0,0,1-.06-.015l-2.094-1.1-2.094,1.1a.129.129,0,0,1-.188-.136l.4-2.331L.039,15.007a.129.129,0,0,1,.072-.221l2.341-.34L3.5,12.325a.135.135,0,0,1,.232,0l1.047,2.121,2.341.34a.129.129,0,0,1,.072.221L5.5,16.658l.4,2.331a.129.129,0,0,1-.128.151ZM3.614,17.75a.129.129,0,0,1,.06.015L5.6,18.775l-.367-2.14a.129.129,0,0,1,.037-.114l1.555-1.516-2.149-.312a.129.129,0,0,1-.1-.071l-.961-1.947-.961,1.947a.129.129,0,0,1-.1.071L.407,15l1.555,1.516A.129.129,0,0,1,2,16.635l-.367,2.14,1.922-1.01A.129.129,0,0,1,3.614,17.75Z'
              transform='translate(-0.902)'
              stroke={fill}
              strokeWidth='0.5'
              fill='url(#linear-gradient-2)'
            />
          </g>
          <g id='star-3-3' data-name='star-3' transform='translate(132.673 278.95)' opacity='0'>
            <path
              id='Path_2085-3'
              data-name='Path 2085'
              d='M12.411,20.992l1.011,2.048,2.26.328-1.636,1.594.386,2.251-2.022-1.063L10.39,27.214l.386-2.251L9.14,23.369l2.26-.328Z'
              transform='translate(-9.477 -8.617)'
              fill='#a4c2f7'
            />
            <path
              id='Path_2086-3'
              data-name='Path 2086'
              d='M18.121,59.454l-2.26-.328-.776-1.562-.729,1.562-2.26.328,1.636,1.594L13.345,63.3l1.618-1,.217.081s0,0,0-.005a.135.135,0,0,1,.162-.092,1.056,1.056,0,0,1,.426.175.16.16,0,0,1,.045.053.112.112,0,0,1,.049.041.132.132,0,0,1,.052-.011.117.117,0,0,1,.119.088.126.126,0,0,1,.186.14l.687.258-.421-1.98Z'
              transform='translate(-12.394 -44.702)'
              fill='url(#linear-gradient)'
            />
            <path
              id='Path_2087-3'
              data-name='Path 2087'
              d='M11.523,175.177l-2.26.328L10.9,177.1l-.386,2.251.581-.305-.008-.014-.13.049.421-1.98-1.636-1.594,1.7-.312Z'
              transform='translate(-9.599 -160.754)'
              fill='#fff'
            />
            <path
              id='Path_2088-3'
              data-name='Path 2088'
              d='M5.768,19.141a.129.129,0,0,1-.06-.015l-2.094-1.1-2.094,1.1a.129.129,0,0,1-.188-.136l.4-2.331L.039,15.007a.129.129,0,0,1,.072-.221l2.341-.34L3.5,12.325a.135.135,0,0,1,.232,0l1.047,2.121,2.341.34a.129.129,0,0,1,.072.221L5.5,16.658l.4,2.331a.129.129,0,0,1-.128.151ZM3.614,17.75a.129.129,0,0,1,.06.015L5.6,18.775l-.367-2.14a.129.129,0,0,1,.037-.114l1.555-1.516-2.149-.312a.129.129,0,0,1-.1-.071l-.961-1.947-.961,1.947a.129.129,0,0,1-.1.071L.407,15l1.555,1.516A.129.129,0,0,1,2,16.635l-.367,2.14,1.922-1.01A.129.129,0,0,1,3.614,17.75Z'
              transform='translate(-0.902)'
              stroke='#5363f6'
              strokeWidth='0.5'
              fill='url(#linear-gradient-2)'
            />
          </g>
          <g id='star-3-4' data-name='star-3' transform='translate(147.673 311.95)' opacity='0.524'>
            <path
              id='Path_2085-4'
              data-name='Path 2085'
              d='M12.411,20.992l1.011,2.048,2.26.328-1.636,1.594.386,2.251-2.022-1.063L10.39,27.214l.386-2.251L9.14,23.369l2.26-.328Z'
              transform='translate(-9.477 -8.617)'
              fill='#a4c2f7'
            />
            <path
              id='Path_2086-4'
              data-name='Path 2086'
              d='M18.121,59.454l-2.26-.328-.776-1.562-.729,1.562-2.26.328,1.636,1.594L13.345,63.3l1.618-1,.217.081s0,0,0-.005a.135.135,0,0,1,.162-.092,1.056,1.056,0,0,1,.426.175.16.16,0,0,1,.045.053.112.112,0,0,1,.049.041.132.132,0,0,1,.052-.011.117.117,0,0,1,.119.088.126.126,0,0,1,.186.14l.687.258-.421-1.98Z'
              transform='translate(-12.394 -44.702)'
              fill='url(#linear-gradient)'
            />
            <path
              id='Path_2087-4'
              data-name='Path 2087'
              d='M11.523,175.177l-2.26.328L10.9,177.1l-.386,2.251.581-.305-.008-.014-.13.049.421-1.98-1.636-1.594,1.7-.312Z'
              transform='translate(-9.599 -160.754)'
              fill='#fff'
            />
            <path
              id='Path_2088-4'
              data-name='Path 2088'
              d='M5.768,19.141a.129.129,0,0,1-.06-.015l-2.094-1.1-2.094,1.1a.129.129,0,0,1-.188-.136l.4-2.331L.039,15.007a.129.129,0,0,1,.072-.221l2.341-.34L3.5,12.325a.135.135,0,0,1,.232,0l1.047,2.121,2.341.34a.129.129,0,0,1,.072.221L5.5,16.658l.4,2.331a.129.129,0,0,1-.128.151ZM3.614,17.75a.129.129,0,0,1,.06.015L5.6,18.775l-.367-2.14a.129.129,0,0,1,.037-.114l1.555-1.516-2.149-.312a.129.129,0,0,1-.1-.071l-.961-1.947-.961,1.947a.129.129,0,0,1-.1.071L.407,15l1.555,1.516A.129.129,0,0,1,2,16.635l-.367,2.14,1.922-1.01A.129.129,0,0,1,3.614,17.75Z'
              transform='translate(-0.902)'
              stroke={fill}
              strokeWidth='0.5'
              fill='url(#linear-gradient-2)'
            />
          </g>
          <g id='star-3-5' data-name='star-3' transform='translate(177.673 320.95)' opacity='0.504'>
            <path
              id='Path_2085-5'
              data-name='Path 2085'
              d='M12.411,20.992l1.011,2.048,2.26.328-1.636,1.594.386,2.251-2.022-1.063L10.39,27.214l.386-2.251L9.14,23.369l2.26-.328Z'
              transform='translate(-9.477 -8.617)'
              fill='#a4c2f7'
            />
            <path
              id='Path_2086-5'
              data-name='Path 2086'
              d='M18.121,59.454l-2.26-.328-.776-1.562-.729,1.562-2.26.328,1.636,1.594L13.345,63.3l1.618-1,.217.081s0,0,0-.005a.135.135,0,0,1,.162-.092,1.056,1.056,0,0,1,.426.175.16.16,0,0,1,.045.053.112.112,0,0,1,.049.041.132.132,0,0,1,.052-.011.117.117,0,0,1,.119.088.126.126,0,0,1,.186.14l.687.258-.421-1.98Z'
              transform='translate(-12.394 -44.702)'
              fill='url(#linear-gradient)'
            />
            <path
              id='Path_2087-5'
              data-name='Path 2087'
              d='M11.523,175.177l-2.26.328L10.9,177.1l-.386,2.251.581-.305-.008-.014-.13.049.421-1.98-1.636-1.594,1.7-.312Z'
              transform='translate(-9.599 -160.754)'
              fill='#fff'
            />
            <path
              id='Path_2088-5'
              data-name='Path 2088'
              d='M5.768,19.141a.129.129,0,0,1-.06-.015l-2.094-1.1-2.094,1.1a.129.129,0,0,1-.188-.136l.4-2.331L.039,15.007a.129.129,0,0,1,.072-.221l2.341-.34L3.5,12.325a.135.135,0,0,1,.232,0l1.047,2.121,2.341.34a.129.129,0,0,1,.072.221L5.5,16.658l.4,2.331a.129.129,0,0,1-.128.151ZM3.614,17.75a.129.129,0,0,1,.06.015L5.6,18.775l-.367-2.14a.129.129,0,0,1,.037-.114l1.555-1.516-2.149-.312a.129.129,0,0,1-.1-.071l-.961-1.947-.961,1.947a.129.129,0,0,1-.1.071L.407,15l1.555,1.516A.129.129,0,0,1,2,16.635l-.367,2.14,1.922-1.01A.129.129,0,0,1,3.614,17.75Z'
              transform='translate(-0.902)'
              stroke={fill}
              strokeWidth='0.5'
              fill='url(#linear-gradient-2)'
            />
          </g>
          <g id='star-3-6' data-name='star-3' transform='translate(160.673 254.95)' opacity='0'>
            <path
              id='Path_2085-6'
              data-name='Path 2085'
              d='M12.411,20.992l1.011,2.048,2.26.328-1.636,1.594.386,2.251-2.022-1.063L10.39,27.214l.386-2.251L9.14,23.369l2.26-.328Z'
              transform='translate(-9.477 -8.617)'
              fill='#a4c2f7'
            />
            <path
              id='Path_2086-6'
              data-name='Path 2086'
              d='M18.121,59.454l-2.26-.328-.776-1.562-.729,1.562-2.26.328,1.636,1.594L13.345,63.3l1.618-1,.217.081s0,0,0-.005a.135.135,0,0,1,.162-.092,1.056,1.056,0,0,1,.426.175.16.16,0,0,1,.045.053.112.112,0,0,1,.049.041.132.132,0,0,1,.052-.011.117.117,0,0,1,.119.088.126.126,0,0,1,.186.14l.687.258-.421-1.98Z'
              transform='translate(-12.394 -44.702)'
              fill='url(#linear-gradient)'
            />
            <path
              id='Path_2087-6'
              data-name='Path 2087'
              d='M11.523,175.177l-2.26.328L10.9,177.1l-.386,2.251.581-.305-.008-.014-.13.049.421-1.98-1.636-1.594,1.7-.312Z'
              transform='translate(-9.599 -160.754)'
              fill='#fff'
            />
            <path
              id='Path_2088-6'
              data-name='Path 2088'
              d='M5.768,19.141a.129.129,0,0,1-.06-.015l-2.094-1.1-2.094,1.1a.129.129,0,0,1-.188-.136l.4-2.331L.039,15.007a.129.129,0,0,1,.072-.221l2.341-.34L3.5,12.325a.135.135,0,0,1,.232,0l1.047,2.121,2.341.34a.129.129,0,0,1,.072.221L5.5,16.658l.4,2.331a.129.129,0,0,1-.128.151ZM3.614,17.75a.129.129,0,0,1,.06.015L5.6,18.775l-.367-2.14a.129.129,0,0,1,.037-.114l1.555-1.516-2.149-.312a.129.129,0,0,1-.1-.071l-.961-1.947-.961,1.947a.129.129,0,0,1-.1.071L.407,15l1.555,1.516A.129.129,0,0,1,2,16.635l-.367,2.14,1.922-1.01A.129.129,0,0,1,3.614,17.75Z'
              transform='translate(-0.902)'
              stroke='#5363f6'
              strokeWidth='0.5'
              fill='url(#linear-gradient-2)'
            />
          </g>
          <g id='star-3-7' data-name='star-3' transform='translate(207.673 323.95)' opacity='0.434'>
            <path
              id='Path_2085-7'
              data-name='Path 2085'
              d='M12.411,20.992l1.011,2.048,2.26.328-1.636,1.594.386,2.251-2.022-1.063L10.39,27.214l.386-2.251L9.14,23.369l2.26-.328Z'
              transform='translate(-9.477 -8.617)'
              fill='#a4c2f7'
            />
            <path
              id='Path_2086-7'
              data-name='Path 2086'
              d='M18.121,59.454l-2.26-.328-.776-1.562-.729,1.562-2.26.328,1.636,1.594L13.345,63.3l1.618-1,.217.081s0,0,0-.005a.135.135,0,0,1,.162-.092,1.056,1.056,0,0,1,.426.175.16.16,0,0,1,.045.053.112.112,0,0,1,.049.041.132.132,0,0,1,.052-.011.117.117,0,0,1,.119.088.126.126,0,0,1,.186.14l.687.258-.421-1.98Z'
              transform='translate(-12.394 -44.702)'
              fill='url(#linear-gradient)'
            />
            <path
              id='Path_2087-7'
              data-name='Path 2087'
              d='M11.523,175.177l-2.26.328L10.9,177.1l-.386,2.251.581-.305-.008-.014-.13.049.421-1.98-1.636-1.594,1.7-.312Z'
              transform='translate(-9.599 -160.754)'
              fill='#fff'
            />
            <path
              id='Path_2088-7'
              data-name='Path 2088'
              d='M5.768,19.141a.129.129,0,0,1-.06-.015l-2.094-1.1-2.094,1.1a.129.129,0,0,1-.188-.136l.4-2.331L.039,15.007a.129.129,0,0,1,.072-.221l2.341-.34L3.5,12.325a.135.135,0,0,1,.232,0l1.047,2.121,2.341.34a.129.129,0,0,1,.072.221L5.5,16.658l.4,2.331a.129.129,0,0,1-.128.151ZM3.614,17.75a.129.129,0,0,1,.06.015L5.6,18.775l-.367-2.14a.129.129,0,0,1,.037-.114l1.555-1.516-2.149-.312a.129.129,0,0,1-.1-.071l-.961-1.947-.961,1.947a.129.129,0,0,1-.1.071L.407,15l1.555,1.516A.129.129,0,0,1,2,16.635l-.367,2.14,1.922-1.01A.129.129,0,0,1,3.614,17.75Z'
              transform='translate(-0.902)'
              stroke={fill}
              strokeWidth='0.5'
              fill='url(#linear-gradient-2)'
            />
          </g>
          <g id='star-3-8' data-name='star-3' transform='translate(220.673 311.95)' opacity='0.3'>
            <path
              id='Path_2085-8'
              data-name='Path 2085'
              d='M12.411,20.992l1.011,2.048,2.26.328-1.636,1.594.386,2.251-2.022-1.063L10.39,27.214l.386-2.251L9.14,23.369l2.26-.328Z'
              transform='translate(-9.477 -8.617)'
              fill='#a4c2f7'
            />
            <path
              id='Path_2086-8'
              data-name='Path 2086'
              d='M18.121,59.454l-2.26-.328-.776-1.562-.729,1.562-2.26.328,1.636,1.594L13.345,63.3l1.618-1,.217.081s0,0,0-.005a.135.135,0,0,1,.162-.092,1.056,1.056,0,0,1,.426.175.16.16,0,0,1,.045.053.112.112,0,0,1,.049.041.132.132,0,0,1,.052-.011.117.117,0,0,1,.119.088.126.126,0,0,1,.186.14l.687.258-.421-1.98Z'
              transform='translate(-12.394 -44.702)'
              fill='url(#linear-gradient)'
            />
            <path
              id='Path_2087-8'
              data-name='Path 2087'
              d='M11.523,175.177l-2.26.328L10.9,177.1l-.386,2.251.581-.305-.008-.014-.13.049.421-1.98-1.636-1.594,1.7-.312Z'
              transform='translate(-9.599 -160.754)'
              fill='#fff'
            />
            <path
              id='Path_2088-8'
              data-name='Path 2088'
              d='M5.768,19.141a.129.129,0,0,1-.06-.015l-2.094-1.1-2.094,1.1a.129.129,0,0,1-.188-.136l.4-2.331L.039,15.007a.129.129,0,0,1,.072-.221l2.341-.34L3.5,12.325a.135.135,0,0,1,.232,0l1.047,2.121,2.341.34a.129.129,0,0,1,.072.221L5.5,16.658l.4,2.331a.129.129,0,0,1-.128.151ZM3.614,17.75a.129.129,0,0,1,.06.015L5.6,18.775l-.367-2.14a.129.129,0,0,1,.037-.114l1.555-1.516-2.149-.312a.129.129,0,0,1-.1-.071l-.961-1.947-.961,1.947a.129.129,0,0,1-.1.071L.407,15l1.555,1.516A.129.129,0,0,1,2,16.635l-.367,2.14,1.922-1.01A.129.129,0,0,1,3.614,17.75Z'
              transform='translate(-0.902)'
              stroke={fill}
              strokeWidth='0.5'
              fill='url(#linear-gradient-2)'
            />
          </g>
          <g id='star-3-9' data-name='star-3' transform='translate(195.673 318.95)' opacity='0.551'>
            <path
              id='Path_2085-9'
              data-name='Path 2085'
              d='M12.411,20.992l1.011,2.048,2.26.328-1.636,1.594.386,2.251-2.022-1.063L10.39,27.214l.386-2.251L9.14,23.369l2.26-.328Z'
              transform='translate(-9.477 -8.617)'
              fill='#a4c2f7'
            />
            <path
              id='Path_2086-9'
              data-name='Path 2086'
              d='M18.121,59.454l-2.26-.328-.776-1.562-.729,1.562-2.26.328,1.636,1.594L13.345,63.3l1.618-1,.217.081s0,0,0-.005a.135.135,0,0,1,.162-.092,1.056,1.056,0,0,1,.426.175.16.16,0,0,1,.045.053.112.112,0,0,1,.049.041.132.132,0,0,1,.052-.011.117.117,0,0,1,.119.088.126.126,0,0,1,.186.14l.687.258-.421-1.98Z'
              transform='translate(-12.394 -44.702)'
              fill='url(#linear-gradient)'
            />
            <path
              id='Path_2087-9'
              data-name='Path 2087'
              d='M11.523,175.177l-2.26.328L10.9,177.1l-.386,2.251.581-.305-.008-.014-.13.049.421-1.98-1.636-1.594,1.7-.312Z'
              transform='translate(-9.599 -160.754)'
              fill='#fff'
            />
            <path
              id='Path_2088-9'
              data-name='Path 2088'
              d='M5.768,19.141a.129.129,0,0,1-.06-.015l-2.094-1.1-2.094,1.1a.129.129,0,0,1-.188-.136l.4-2.331L.039,15.007a.129.129,0,0,1,.072-.221l2.341-.34L3.5,12.325a.135.135,0,0,1,.232,0l1.047,2.121,2.341.34a.129.129,0,0,1,.072.221L5.5,16.658l.4,2.331a.129.129,0,0,1-.128.151ZM3.614,17.75a.129.129,0,0,1,.06.015L5.6,18.775l-.367-2.14a.129.129,0,0,1,.037-.114l1.555-1.516-2.149-.312a.129.129,0,0,1-.1-.071l-.961-1.947-.961,1.947a.129.129,0,0,1-.1.071L.407,15l1.555,1.516A.129.129,0,0,1,2,16.635l-.367,2.14,1.922-1.01A.129.129,0,0,1,3.614,17.75Z'
              transform='translate(-0.902)'
              stroke={fill}
              strokeWidth='0.5'
              fill='url(#linear-gradient-2)'
            />
          </g>
          <g id='star-3-10' data-name='star-3' transform='translate(207.673 258.177)' opacity='0'>
            <path
              id='Path_2085-10'
              data-name='Path 2085'
              d='M10.877,20.992l.537,1.088,1.2.174-.869.847.205,1.2-1.074-.564L9.8,24.3l.205-1.2-.869-.847,1.2-.174Z'
              transform='translate(-9.742 -8.671)'
              fill='#a4c2f7'
            />
            <path
              id='Path_2086-10'
              data-name='Path 2086'
              d='M15.3,58.567l-1.2-.174-.412-.83-.387.83-1.2.174.869.847-.205,1.2.859-.531.115.043s0,0,0,0a.072.072,0,0,1,.086-.049.561.561,0,0,1,.226.093.085.085,0,0,1,.024.028.059.059,0,0,1,.026.022.07.07,0,0,1,.028-.006.062.062,0,0,1,.063.047.067.067,0,0,1,.1.074l.365.137-.224-1.052Z'
              transform='translate(-12.677 -44.984)'
              fill='url(#linear-gradient)'
            />
            <path
              id='Path_2087-10'
              data-name='Path 2087'
              d='M10.463,175.177l-1.2.174.869.847-.205,1.2.308-.162,0-.008-.069.026.224-1.052-.869-.847.9-.166Z'
              transform='translate(-9.864 -161.769)'
              fill='#fff'
            />
            <path
              id='Path_2088-10'
              data-name='Path 2088'
              d='M3.063,15.914a.069.069,0,0,1-.032-.008l-1.112-.584-1.112.584a.069.069,0,0,1-.1-.072L.92,14.6l-.9-.877A.069.069,0,0,1,.059,13.6L1.3,13.421l.556-1.126a.071.071,0,0,1,.123,0l.556,1.126L3.78,13.6a.069.069,0,0,1,.038.117l-.9.877.212,1.238a.069.069,0,0,1-.068.08Zm-1.144-.739a.068.068,0,0,1,.032.008l1.021.536-.195-1.136a.069.069,0,0,1,.02-.061l.826-.8-1.141-.166a.069.069,0,0,1-.052-.038l-.51-1.034-.51,1.034a.069.069,0,0,1-.052.038l-1.141.166.826.8a.069.069,0,0,1,.02.061L.867,15.719l1.021-.536A.068.068,0,0,1,1.919,15.175Z'
              transform='translate(-0.902 0)'
              stroke='#5363f6'
              strokeWidth='0.5'
              fill='url(#linear-gradient-2)'
            />
          </g>
          <g id='star-3-11' data-name='star-3' transform='translate(186.673 262.177)' opacity='0'>
            <path
              id='Path_2085-11'
              data-name='Path 2085'
              d='M10.877,20.992l.537,1.088,1.2.174-.869.847.205,1.2-1.074-.564L9.8,24.3l.205-1.2-.869-.847,1.2-.174Z'
              transform='translate(-9.742 -8.671)'
              fill='#a4c2f7'
            />
            <path
              id='Path_2086-11'
              data-name='Path 2086'
              d='M15.3,58.567l-1.2-.174-.412-.83-.387.83-1.2.174.869.847-.205,1.2.859-.531.115.043s0,0,0,0a.072.072,0,0,1,.086-.049.561.561,0,0,1,.226.093.085.085,0,0,1,.024.028.059.059,0,0,1,.026.022.07.07,0,0,1,.028-.006.062.062,0,0,1,.063.047.067.067,0,0,1,.1.074l.365.137-.224-1.052Z'
              transform='translate(-12.677 -44.984)'
              fill='url(#linear-gradient)'
            />
            <path
              id='Path_2087-11'
              data-name='Path 2087'
              d='M10.463,175.177l-1.2.174.869.847-.205,1.2.308-.162,0-.008-.069.026.224-1.052-.869-.847.9-.166Z'
              transform='translate(-9.864 -161.769)'
              fill='#fff'
            />
            <path
              id='Path_2088-11'
              data-name='Path 2088'
              d='M3.063,15.914a.069.069,0,0,1-.032-.008l-1.112-.584-1.112.584a.069.069,0,0,1-.1-.072L.92,14.6l-.9-.877A.069.069,0,0,1,.059,13.6L1.3,13.421l.556-1.126a.071.071,0,0,1,.123,0l.556,1.126L3.78,13.6a.069.069,0,0,1,.038.117l-.9.877.212,1.238a.069.069,0,0,1-.068.08Zm-1.144-.739a.068.068,0,0,1,.032.008l1.021.536-.195-1.136a.069.069,0,0,1,.02-.061l.826-.8-1.141-.166a.069.069,0,0,1-.052-.038l-.51-1.034-.51,1.034a.069.069,0,0,1-.052.038l-1.141.166.826.8a.069.069,0,0,1,.02.061L.867,15.719l1.021-.536A.068.068,0,0,1,1.919,15.175Z'
              transform='translate(-0.902 0)'
              stroke='#5363f6'
              strokeWidth='0.5'
              fill='url(#linear-gradient-2)'
            />
          </g>
        </g>
        <g id='noun_date_1757903' transform='translate(506.682 434.208)'>
          <path
            id='Path_2138'
            data-name='Path 2138'
            d='M23.18,5.741H20.6V4.467A1.071,1.071,0,0,0,19.538,3.4,1.049,1.049,0,0,0,18.5,4.467V5.741H11.214V4.467A1.071,1.071,0,0,0,10.148,3.4,1.055,1.055,0,0,0,9.081,4.467V5.741H6.532A4.035,4.035,0,0,0,2.5,9.773V23.586a4.035,4.035,0,0,0,4.032,4.032H23.18a4.035,4.035,0,0,0,4.032-4.032V9.773A4.052,4.052,0,0,0,23.18,5.741ZM6.532,7.848H9.107V9.123a1.071,1.071,0,0,0,1.067,1.067A1.055,1.055,0,0,0,11.24,9.123V7.848h7.284V9.123a1.071,1.071,0,0,0,1.067,1.067,1.055,1.055,0,0,0,1.067-1.067V7.848H23.18a1.921,1.921,0,0,1,1.925,1.925v3.122H4.607V9.773A1.921,1.921,0,0,1,6.532,7.848Z'
            transform='translate(-329 -250)'
            fill='url(#linear-gradient-23)'
          />
        </g>
      </g>
    </svg>
  )
);
BookedIcon.displayName = 'BookedIcon';

export default BookedIcon;
